import { createContext, useContext, useState, useEffect } from 'react'

// Matches Bootstrap lg breakpoint used by Sidenavbar (d-lg-none / d-lg-flex)
export const DESKTOP_SIDEBAR_MIN_WIDTH = 992

const SidebarContext = createContext()

export const SidebarProvider = ({ children }) => {
  // Get initial state from localStorage or default to false (expanded)
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed')
    return saved ? JSON.parse(saved) : false
  })

  // Save to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(isCollapsed))
  }, [isCollapsed])

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev)
  }

  return (
    <SidebarContext.Provider value={{ isCollapsed, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  )
}

export const useSidebar = () => useContext(SidebarContext)

